import ReduxableService from './parentСlasses/ReduxableService'

import { setRoute } from '../actions/service';
import * as actions from '../actions/route';


export default class RouteService extends ReduxableService {

  colorPalette = [
    '#d00000',
    '#00d000',
    '#0000d0',
    '#d0d000',
    '#d000d0',
    '#00d0d0',
    '#d0d0d0',
    '#000000',
    '#606060',
    
  ];
  currentColor=0
  loadExtData={}


  constructor(store) {
    super(store, actions, setRoute)
  }
  /**Запускает загрузку маршрута */
  loadRoute = ({loadCriteria, naming}) => {
    const {getGeoObjRoute} = this.rr.service_Api;
    const {rangeNamer, name} = naming
    this.loadExtData={dataRange:rangeNamer, name}
    getGeoObjRoute(loadCriteria)
    this.actions.setRoutePaletteStatus(true)
    //   loadCriteria:{
    //     objId:id,
    //     criteria           
    // },
    // naming:{
    //     rangeNamer,
    //     objId:id,
    //     name,
    // }
    // if(!this.loadQueue.includes(dirName) && !this.loaded.includes(dirName) && this.curentLoad!==dirName){
    //   this.loadQueue=[...this.loadQueue, dirName]
    //   this._trayToStartLoad()
    // }
  }
  addRouteArr = (routeArr, activate=true) => {
    const { route_routeArr=[], route_routeSettingsArr=[] } = this.rr
    this.actions.setRouteArr([...route_routeArr, routeArr])
    this.actions.setRouteSettingsArr([
      ...(activate?route_routeSettingsArr.map((setings)=>({...setings, active:false})):route_routeSettingsArr), 
      {...this.loadExtData, active:activate, color:this.colorPalette[this.currentColor],points:routeArr.length}
    ])
    this.currentColor++
    if(this.currentColor===this.colorPalette.length) this.currentColor=0
  }
  updateRouteSettingsArr = (arr) => {
    this.actions.setRouteSettingsArr(arr)
  }
  deleteRoute = (i) => {
    const { route_routeArr=[], route_routeSettingsArr=[] } = this.rr
    this.actions.setRouteArr(route_routeArr.filter((foo,index)=>index!==i))
    this.actions.setRouteSettingsArr(route_routeSettingsArr.filter((foo,index)=>index!==i))
  }
  //внутренние функции
  _storeListener = () => {

    if (this._isChange('api_geoObjRoute')) {
      const {loading, data, error} = this.rr.api_geoObjRoute || {}

      if(!loading){
        if(!error && data?.length){
          //Что-то делаем с маршрутом
          this.addRouteArr(data)
        }else{
          if(!this.rr.route_routeArr?.length) this.actions.setRoutePaletteStatus(false)

        }
      }
    }
  }
}
/*
    get route_routeArr(){
      return this._route.routeArr
    }
    get route_routeSettingsArr(){
      return this._route.routeSettingsArr
    }
    get route_paletteStatus(){
      return this._route.paletteStatus
    }
*/